import React from "react";
import { Building2, FileText } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function LeaseEnrichmentPanel({ enrichment }) {
  const { t } = useTranslation("components");
  const e = enrichment || {};
  return (
    <section
      className="bg-white border border-zinc-200 rounded-xl p-6"
      data-testid="lease-enrichment-panel"
    >
      <div className="flex items-center gap-2 mb-5">
        <div className="w-7 h-7 rounded-md grid place-items-center bg-indigo-50 text-indigo-700">
          <Building2 size={14} strokeWidth={1.75} />
        </div>
        <h2 className="font-display font-semibold text-base tracking-tight">{t("enrichment.lease.section_title")}</h2>
      </div>
      <div className="grid sm:grid-cols-3 gap-4 mb-6">
        <div>
          <p className="text-[11px] uppercase tracking-[0.18em] text-zinc-500 mb-1">{t("enrichment.lease.lease_type")}</p>
          <p className="font-display font-semibold text-zinc-950" data-testid="lease-enrich-type">{e.lease_type || "—"}</p>
        </div>
        <div>
          <p className="text-[11px] uppercase tracking-[0.18em] text-zinc-500 mb-1">{t("enrichment.lease.duration")}</p>
          <p className="font-display font-semibold text-zinc-950" data-testid="lease-enrich-duration">
            {e.duration_months ? t("enrichment.lease.duration_value", { count: e.duration_months }) : "—"}
          </p>
        </div>
        <div>
          <p className="text-[11px] uppercase tracking-[0.18em] text-zinc-500 mb-1">{t("enrichment.lease.security_deposit")}</p>
          <p className="font-display font-semibold text-zinc-950" data-testid="lease-enrich-deposit">{e.security_deposit || "—"}</p>
        </div>
      </div>
      {e.premises && (
        <div className="mb-5" data-testid="lease-enrich-premises">
          <p className="text-[11px] uppercase tracking-[0.18em] text-zinc-500 mb-1">{t("enrichment.lease.premises")}</p>
          <p className="text-sm text-zinc-800">{e.premises}</p>
        </div>
      )}
      {e.rent_schedule?.length > 0 && (
        <div className="mb-5" data-testid="lease-enrich-rent-schedule">
          <p className="text-[11px] uppercase tracking-[0.18em] text-zinc-500 mb-2">{t("enrichment.lease.rent_schedule")}</p>
          <ul className="divide-y divide-zinc-100">
            {e.rent_schedule.map((r, i) => (
              <li key={i} className="flex items-baseline justify-between py-2 text-sm">
                <span className="text-zinc-700">{r.period}</span>
                <span className="font-semibold text-zinc-950 tabular-nums">{r.amount}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
      {e.important_clauses?.length > 0 && (
        <div data-testid="lease-enrich-clauses">
          <p className="text-[11px] uppercase tracking-[0.18em] text-zinc-500 mb-2">{t("enrichment.lease.important_clauses")}</p>
          <ul className="space-y-2">
            {e.important_clauses.map((c, i) => (
              <li key={i} className="flex gap-2 text-sm text-zinc-700 leading-relaxed">
                <FileText size={13} className="shrink-0 mt-0.5 text-zinc-400" />
                <span>{c}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </section>
  );
}
